/**
 * Delay function
 *
 * @param {Function} fn - Function that you want a delay execution
 * @param {Number} wait - This time delay (ms)
 * @returns Function delay
 */
export function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * Delay function
 *
 * @param {Function} fn - Function that you want a delay execution
 * @param {Number} wait - This time delay (ms)
 * @returns Function delay
 */
export async function debouncePromise(wait) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, wait);
  });
}
